import { ContentPermissionLevel, type ContentPermissionLevelOrNone } from '../content';

/**
 * Role of a user in an organization.
 * We currently use the exact same values for roles and permissions values.
 * We could improve this by completely discriminating both enums but it will require
 * some work, for example in the permissions compute function that mixes both.
 */
export { ContentPermissionLevel as OrganizationMemberRole };

export type OrganizationMemberRoleOrGuest = ContentPermissionLevelOrNone;

/**
 * Name and one-line summary of each role, as the product presents them.
 */
export const MEMBER_ROLE_LABELS: Record<
    ContentPermissionLevel,
    { title: string; description: string }
> = {
    [ContentPermissionLevel.Admin]: {
        title: 'Administrator',
        description: 'Can do everything',
    },
    [ContentPermissionLevel.Create]: {
        title: 'Creator',
        description: 'Create, publish, merge and edit',
    },
    [ContentPermissionLevel.Review]: {
        title: 'Reviewer',
        description: 'Review and merge change requests',
    },
    [ContentPermissionLevel.Edit]: {
        title: 'Editor',
        description: 'Edit pages, submit change requests',
    },
    [ContentPermissionLevel.Comment]: {
        title: 'Commenter',
        description: 'Read content and comment',
    },
    [ContentPermissionLevel.Read]: {
        title: 'Reader',
        description: 'Read-only access',
    },
};

/**
 * Name and one-line summary of a member without an organization role.
 */
export const GUEST_ROLE_LABEL = { title: 'Guest', description: 'No default access' };
